<!-- 
<div class="container" >
    <h6 class="heading text-center nav-heading">{{title}}</h6>
    <div class="row counter">
        <div class="activity-history" *ngFor="let item of timeline;let i=index">
            <div class="activity-date-time" style="--line-num: 1;" data-content="i">
                <div>
                   
                    <hr class="m-0">
                    <p>

                    </p>
                    <div class="activity-user d-block" style="padding-left: 1.5rem;">
                        <div class="d-inline-block">
                            <span *ngIf="item.notes && item.notes != '';else no_record">
                                <span class="item" [innerHTML]="item.notes  | HTMLFormatter"></span>

                                

                                <span *ngIf="item.description && item.description != ''">
                                    {{item.description}}
                                </span>
                            </span>
                            <ng-template #no_record>
                                <div style="visibility: hidden;min-height: 35px;">1</div>
                            </ng-template>
                        </div>
                        <div class="d-inline-block float-right">
                            <p class="p-0 m-0" style="font-style: italic; font-size: 12px;">
                                <span *ngIf="item.cr_name && item.cr_name != ''"> By <i class="fa fa-user"></i>
                                    {{item.cr_name}}
                                </span>
                                <i class="fa fa-clock-o"></i> {{item.cr_date | date: 'd-MMM-yyyy'}} {{item.cr_date | date: 'h:mm a'}}
                            </p>
                        </div>
                    </div>
                </div>
            </div> -->



<main *ngIf="timeline && timeline.length">
    <div *ngFor="let item of timeline;let i=index">
        <div  [ngClass]="(i%2==0 ? 'odd_note' : 'note') + ' ' + (i==0 ? 'first_note':'')" *ngIf="item.notes && item.notes != ''">
           <div class="back">
            <p style="margin: 0;" [innerHTML]="item.notes  | HTMLFormatter"> </p>
            <p style="margin: 0;text-align: right;line-height: 1rem;">
        <span class="info" *ngIf="item.cr_name && item.cr_name != ''">
            By &nbsp;<i class="fa fa-user"></i> {{item.cr_name}}
        </span>
        <br>
        <span class="info">
            <i class="fa fa-clock-o"></i> {{item.cr_date | date: 'd-MMM-yyyy'}} {{item.cr_date | date: 'h:mm a'}}
        </span>
    </p>
    </div>
        </div>
    </div>
</main>